import React from 'react';
import { Button } from "@amzn/awsui-components-react";
import { APP_EDIT_ROLE_METRICS } from '../Constants';
import { ACTION_METHODS } from 'src/katalMetrics/metricsModels';
import { captureAppEditRoleMetric } from '../Utils/appEditRoleMetrics';

// Edit entry point for a user holding a limited-edit app role (e.g. GRC control owner).
// Hidden while editing; records a BUTTON_CLICK metric tagged with the role id.
const LimitedEditButton = ({ role, isEditMode, onEdit, children }) => {
  if (!role || isEditMode) return null

  const handleClick = () => {
    captureAppEditRoleMetric(ACTION_METHODS.BUTTON_CLICK, role, APP_EDIT_ROLE_METRICS.START_EDIT)
    onEdit()
  }

  return (
    <span>
      <Button iconName="edit" variant="icon" ariaLabel={`Edit as ${role.label} (limited)`} onClick={handleClick} />
      <>{children}</>
    </span>
  )
}

export default LimitedEditButton;
